import { useMemo } from "react";
import { useTranslation } from "react-i18next"
import { renderOrgLevelResourceLabel } from "../../../../../../../utils/helpers/settings";
import { useGroups } from "../../../../../General/OrganisationLevelGroups/context";

export const useOrganizationConfig = () => {
    const { t } = useTranslation();
    const { groups } =useGroups()

    return useMemo(() => {
        const base = [
            {
                name: t("effective-date"),
                key: "startDate",
            },
        ];

        const dynamicLevels = (groups || []).map(
            ({ level, code, description, glSegment }) => ({
                name: renderOrgLevelResourceLabel({
                    code,
                    description,
                    glSegment,
                }),
                key: `${level}`.replace("_", ""),
            }));
        return [...base, ...dynamicLevels];
    }, [groups, t]);
}